import {
  Grid,
  Box,
  Button,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  CircularProgress,
  Typography,
} from "@mui/material";
import { Container } from "@mui/system";
import Paper from "@mui/material/Paper";
import { useNavigate, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import Stack from "@mui/material/Stack";
import instance from "../api/api";
import {
  AddAPhoto,
  CloseOutlined,
  CloseRounded,
  DeleteOutline,
  DeselectOutlined,
} from "@mui/icons-material";

import HighlightOffIcon from "@mui/icons-material/HighlightOff";

import React, { useEffect, useState, useContext } from "react";
import Avatar from "@mui/material/Avatar";
import CssBaseline from "@mui/material/CssBaseline";
import Notifications from "@mui/icons-material/Notifications";
import HelpIcon from "@mui/icons-material/Help";
import { makeStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
// import Alert from "@material-ui/lab/Alert";
import jwt_decode from "jwt-decode";
import { Context } from "../context/ContextProvider";
import Loading from "../components/Item";
import LoginIcon from "@mui/icons-material/Login";
import axios from "axios";
import instanceMerchant from "../api/apiMerchant";
const useStyles = makeStyles((theme) => ({
  "@global": {
    password: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(0),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  table: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
  },
  avatar: {
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  icons: {
    display: "flex",
    flexDirection: "row",
    position: "fixed",
    top: 5,
    right: 5,
  },
}));

let req;
function AddProduct({ i18n, t }) {
  const {
    isAdmin,
    setIsAdmin,
    setIsLoading,
    token,
    setToken,
    isActive,
    setIsActive,
  } = useContext(Context);
  let navigate = useNavigate();
  const { state } = useLocation();
  const [unmounted, setUnmounted] = useState(true);
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [images, setImages] = React.useState([]);
  const [isUpload, setIsUpload] = React.useState(false);
  const [loadingImage, setLoadingImage] = React.useState(false);

  useEffect(() => {
    // console.log("data: ", state);
    state != null && setImages(state.product.image.split(","));
  }, []);
  const [newOject, setNewObject] = useState({
    name: state != null ? state.product.name : "",
    code: "#ffffff",
    unit: state != null ? state.product.unit : 0,
    description:
      state != null
        ? state.product.description.replace(/<\/?[^>]+(>|$)/g, "")
        : "",
    category_id: state != null ? state.product.category_id : 50,
    after_vat: state != null ? state.product.after_vat : 0,
    basicPrice: state != null ? state.product.basicPrice : 0,
    qty: state != null ? state.product.qty : 0,
    serialNumber: "",
    category: "جديدنا",
    stock: state != null ? state.product.stock : 0,
    // stock: newOject?.stock && newOject.stock > 0 ? newOject.stock : 1000000,
    image: state != null ? state.product.image : "",
    imageLocaly: "",
  });

  // const {
  //   // messages,
  //   // setMessages,
  //   // user,
  //   // setUser,
  // } = useContext(Context);

  //   useEffect(() => {
  //     console.log("data: ",state.product);
  //     if (isLogin) setUnmounted(true);
  //     return () => {
  //       setIsLogin(true);
  //     };
  //   }, [isLogin]);

  const classes = useStyles();
  const handleFields = (e) => {
    setNewObject({ ...newOject, [e.target.name]: e.target.value });
  };

  const addNewProduct = async (e) => {
    e.preventDefault();
    setError("");
    // setNewObject({ ...newOject, image: "jjjjj" });

    // const email = newOject.email;
    // const password = newOject.password;
    // if (email === "" || password === "") {
    //   alert("email/password cannot be empty");
    //   return;
    // }

    setLoading(true);
    try {
      if (state != null) {
        req = await instanceMerchant.post(`/products/update-product`, {
          ...newOject,
          image: images.toString(),
          _id: state.product._id,
        });
      } else {
        req = await instanceMerchant.post(`/products/create-product`, {
          ...newOject,
          image: images.toString(),
        });
      }
      if (unmounted) {
        setIsLogin(false);
        setUnmounted(false);

        setLoading(false);

        setIsLoading(false);
        state != null ? navigate(`/${state.product._id}`) : navigate(`/home`);
      } else {
        setError("You can't access this page.");
      }
    } catch (error) {
      console.log("jjj", error.message);
      setLoading(false);
      setError(error.message);
    }
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "red" : "#ffffff",
    ...theme.typography.body2,
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  }));

  const [file, setFile] = React.useState(null);
  const [imageName, setImageName] = React.useState(
    "https://storage.googleapis.com/proudcity/mebanenc/uploads/2021/03/placeholder-image.png"
  );

  const onSubmit = (e) => {
    e.preventDefault();
    setLoadingImage(true);
    const formData = new FormData();
    formData.append("image", file);
    instance
      .post(
        "https://fatora-sa.herokuapp.com/api/v1/products/create-one-image",
        formData,
        {
          headers: {
            "Contant-Type": "multipart/form-data",
          },
        }
      )
      .then(
        ({ data }) =>
          setIsUpload(true) &
          setImages((perv) => [
            `https://fatora-sa.herokuapp.com/api/v1/products/${data.createOneImage}`,
            ...perv,
          ]) &
          setTimeout(() => {
            setLoadingImage(false);
            setNewObject({ ...newOject, image: images?.toString() });
          }, 3000)
      )
      .catch((e) => console.log("error: ", e.message));
  };

  const onChange = (e) => {
    setFile(e.target.files[0]);
    var src = URL.createObjectURL(e.target.files[0]);
    setImageName(src);
  };

  const deleteImage = async (key) => {
    const deleteOneImage = images[key].replace(/^.*[\\\/]/, "");
    // console.log("deleteOneImage: ", deleteOneImage.replace(/^.*[\\\/]/, ""));
    // console.log("filename: ", filename);
    // console.log("itemImage: ", itemImage);
    // itemImage == "undefined" && setAlbume([]);
    // const removeItem =
    //   itemImage == "undefined" ? itemImage.replace(/^.*[\\\/]/, "") : null;
    try {
      await instance
        .post("/products/delete-one-image", {
          filename: deleteOneImage,
        })
        .then(({ data }) => {
          console.log("result: ", data.result);
          // setIsDeleteImage(true);
          // setAlbume([]);
        });
    } catch (error) {
      console.log("error: ", error.message);
    }

    setImages(images.filter((img, i) => i !== key));
  };

  return (
    <Container style={{ paddingTop: 50, paddingBottom: 100 }}>
      <Typography variant="h4" style={{ marginBottom: 0 }} p={2} pt={1} pb={0}>
        إضافة منتج
      </Typography>
      <Grid container p={2} pt={0}>
        <Grid item style={{ textAlign: "center" }} xs={12} sm={6} md={6} lg={6}>
          <form onSubmit={onSubmit}>
            <Item>
              <Button
                variant="text"
                component="label"
                style={{ color: "black", position: "absolute" }}
              >
                {loadingImage ? (
                  <CircularProgress size={25} />
                ) : (
                  <AddAPhoto size={25} />
                )}
                <input
                  hidden
                  accept="image/*"
                  multiple
                  type="file"
                  onChange={onChange}
                />
              </Button>

              <Box
                component="img"
                sx={{
                  height: "100%",
                  width: "100%",
                }}
                alt={"apple"}
                src={file == null && state != null ? images[0] : imageName}
              />
            </Item>
            <Button
              sx={{ mt: 2, p: 2 }}
              variant="contained"
              fullWidth
              type="submit"
            >
              تحميل الصورة
            </Button>
          </form>
        </Grid>

        {images.map((image, key) => (
          <Grid
            item
            style={{ textAlign: "center" }}
            xs={3}
            sm={1}
            md={1}
            lg={1}
            m={0}
            p={1 / 2}
            pt={0}
            key={key}
          >
            <Item>
              <Box
                component="img"
                sx={{
                  height: "100%",
                  width: "100%",
                }}
                alt={"apple"}
                src={image}
              />
            </Item>
            <Button
              fullWidth
              variant="text"
              style={{ color: "red", borderColor: "red", borderRadius: 0 }}
              onClick={() => deleteImage(key)}
            >
              <HighlightOffIcon />
            </Button>
          </Grid>
        ))}

        <Grid
          item
          style={{ textAlign: "center" }}
          xs={12}
          sm={12}
          md={12}
          lg={12}
          m={0}
          p={1 / 2}
          pt={0}
        >
          <form noValidate onSubmit={addNewProduct} id="formR">
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="name"
              name="name"
              value={newOject.name}
              onChange={(e) => handleFields(e)}
              autoComplete="name"
              autoFocus
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="unit"
              name="unit"
              value={newOject.unit}
              onChange={(e) => handleFields(e)}
              autoComplete="unit"
              autoFocus
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="description"
              name="description"
              multiline
              value={newOject.description}
              onChange={(e) => handleFields(e)}
              autoComplete="description"
              autoFocus
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="basicPrice"
              name="basicPrice"
              value={newOject.basicPrice}
              onChange={(e) => handleFields(e)}
              autoComplete="basicPrice"
              autoFocus
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="qty"
              name="qty"
              value={newOject.qty}
              onChange={(e) => handleFields(e)}
              autoComplete="qty"
              autoFocus
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="stock"
              name="stock"
              value={newOject.stock}
              onChange={(e) => handleFields(e)}
              autoComplete="stock"
              autoFocus
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              style={{ background: "green", color: "#ffffff" }}
              //   className={classes.submit}
              sx={{ mt: 2, p: 2 }}
            >
              {loading ? (
                <CircularProgress style={{ color: "#ffffff" }} size={20} />
              ) : state != null ? (
                "تعديل المنتج"
              ) : (
                "إضافة المنتج"
              )}
            </Button>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
}

export default AddProduct;
